import styled from 'styled-components';
import {COLORS} from '@fupa/fupa-uikit';

const FederatedButton = styled.button`
  margin: 0.25rem;
  padding-left: 0;
  padding-right: 0.75rem;
  background-color: ${(props) => props.color || COLORS.white};
  border: ${(props) => (!props.color ? `1px solid ${COLORS.grey}` : 'none')};
  border-radius: 0.25rem;
  display: flex;
  height: 2.25rem;
  width: 14.5rem;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  justify-items: center;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  cursor: pointer;
`;

const Icon = styled.img`
  margin: 0 0 0 0.75rem;
`;

const Label = styled.span`
  margin-left: 0.75rem;
  display: flex;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  font-size: 1rem;
  color: ${(props) => props.color || COLORS.black};
  text-overflow: ellipsis;
`;

export {FederatedButton, Icon, Label};
